import React, {useEffect} from 'react';
import ActionItemAssign from './ActionItemAssign.mjs';
import ActionItemDropdownPriorities from './ActionItemDropdownPriorities.mjs';
import FilePicker from './FilePicker.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemDropdownFormTeamList({sel_action_item, action}) 
{
    const { app_user, action_item, team_member_role, setSelectedActionItem, setActionItemDisplayRefresh } = useCTAL();
    
    useEffect(() =>
    {
        if (!sel_action_item) return;
        
        //Only show Delete Action if current app_user is the creator of the Action OR App User is a Team Admin, else hide
        var display_txt = "none";
        if ((sel_action_item.CreatedBy == app_user.UserFullName) || (team_member_role == "Admin")) display_txt = "block";
        
        document.getElementById(sel_action_item.Name+"-divider").style.display = display_txt;
        document.getElementById(sel_action_item.Name+"-delete").style.display = display_txt;
    }, [sel_action_item]);

    const refresh_action_item = () => { 
        //Only Refresh Action Item if it's already selected
        if ((action_item != undefined) && (action_item.Name == sel_action_item.Name)) {
            setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
            setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs     
        }
    }

    const AddComment = () => { 
        var comment = document.getElementById(sel_action_item.ActionItemID);
        action("create_comment", comment.value)
        comment.value = "";
    }

    //TODO drop_items = [...drop_items, "Assign"];  

    const picker_prefix = "TeamList";
    const assign_prefix = sel_action_item.ActionItemID;

    return (
        <div class="dropdown-menu">
            <a class="dropdown-item" href="#" onClick={ () => action("take_action_item") }>Take (to Short List)</a>
            <a class="dropdown-item" href="#" onClick={ () => action("close_action_item") }>Close Action</a>

            <form class="px-2 py-1">
          
                <div class="row">
                    <div class="col ms-2 mb-2">
                        <ActionItemDropdownPriorities action_item={sel_action_item} action={action} />
                    </div>
                </div>   

                <div class="row mb-2">
                    <div class="col">
                        <ActionItemAssign action_item={sel_action_item} assign_prefix={assign_prefix}/>
                    </div>
                </div>   

                <FilePicker home_team_id={sel_action_item.HomeTeamID} target_type={sel_action_item.Type} target_id={sel_action_item.ActionItemID} refresh_target = {refresh_action_item} picker_prefix={picker_prefix} /> 

                <div class="row mt-2">
                    <div class="col">
                        <div class="form-floating form-floating-sm mb-0">
                        <textarea id={sel_action_item.ActionItemID} class="form-control" placeholder="Add Comment"></textarea>
                        <label class="select-floating-label" htmlFor="floatingSelect">Add Comment</label>
                        </div>
                    </div>
                </div>   
                
                <div class="row">
                    <div class="col mt-1 text-end">
                        <button type="button" class="btn btn-sm btn-outline-secondary" onClick={ () => AddComment() }>Add</button>
                    </div>
                </div>   

            </form>
            <div id={sel_action_item.Name+"-divider"} class="dropdown-divider"></div>
            <a id={sel_action_item.Name+"-delete"} class="dropdown-item" href="#" onClick={ () => action("delete_action_item_ui") }>Delete Action</a>
        </div>
    );
}